export class User {
    constructor(
        public id: string,
        public email: string,
        public password: string,
        public profile: string,
        public nome: string
    ){}
}